import React, { type VFC } from 'react';

import { PageIncludeMacroHandler } from '@confluence/page-include-macro/entry-points/PageIncludeMacroRenderer.ts';
import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import type { RendererExtensionHandlers } from '@confluence/fabric-extension-lib/entry-points/extensionTypes.ts';

import { NestedAdfSSRRendererWrapperProvider } from './NestedAdfSSRRendererWrapperProvider.tsx';

type PageIncludeSSRExtensionHandlerProps = ExtensionHandlerProps & {
	appearance?: string;
	Renderer: VFC<any>;
	getExtensionHandlers: (options: any) => RendererExtensionHandlers;
};

export const PageIncludeSSRExtensionHandler: VFC<PageIncludeSSRExtensionHandlerProps> = ({
	contentId,
	extensionKey,
	mode,
	node,
	spaceKey,
	appearance,
	showTemplateVariablesInPreview,
	showTemplateInputInPreview,
	Renderer,
	getExtensionHandlers,
}) => (
	<NestedAdfSSRRendererWrapperProvider
		appearance={appearance}
		Renderer={Renderer}
		getExtensionHandlers={getExtensionHandlers}
		showTemplateInputInPreview={showTemplateInputInPreview}
		showTemplateVariablesInPreview={showTemplateVariablesInPreview}
	>
		{(RendererWrapper) => (
			<PageIncludeMacroHandler
				macroDefaultProps={{
					contentId,
					extensionKey,
					mode,
					node,
					spaceKey,
				}}
				macroParams={node?.parameters?.macroParams}
				RendererWrapper={RendererWrapper}
			/>
		)}
	</NestedAdfSSRRendererWrapperProvider>
);
